import React, { useEffect, useState } from "react";
import "./hydrafacial.css";
import { useNavigate, Link, useLocation } from "react-router-dom";
import heroImage from "../../../assets/images/ad-co2.jpg";
import heroImage1 from "../../../assets/images/ad-co21.jpg";
import favicon from "../../../assets/images/favicon.ico";

import deepCleansingIcon from "../../../assets/images/deep-cleansing.png";
import enhancedHydrationIcon from "../../../assets/images/enhanced-hydration.png";
import skinRenewalIcon from "../../../assets/images/skin-renewal.png";
import nonInvasiveIcon from "../../../assets/images/non-invasive.png";

// Import PNG icons for navigation treatments
import hydrafacialIcon from "../../../assets/images/botox.png";
import acneIcon from "../../../assets/images/navacne.png";
import skinBrighteningIcon from "../../../assets/images/skin-brightening.png";
import antiAgeingIcon from "../../../assets/images/anti-ageing.png";
import youthIcon from "../../../assets/images/youth.png";
import prpFaceIcon from "../../../assets/images/prpface.png";
import co2FacialIcon from "../../../assets/images/co2.png";
import acneScarIcon from "../../../assets/images/acnescar.png";
import moleBirthMarkIcon from "../../../assets/images/wart.png";
import tattoRemovalIcon from "../../../assets/images/tattoo.png";
import wartsRemovalIcon from "../../../assets/images/blackhead.png";
import antiAgeingLaserIcon from "../../../assets/images/laser.png";
import laserHairRemovalIcon from "../../../assets/images/laserHairRemoval.png";

const treatments = [
  { name: "ADVANCED HYDRAFACIAL" },
  { name: "ACNE" },
  { name: "ANTI AGEING" },
  { name: "YOUTH" },
  { name: "PRP FACE" },
  { name: "CO2 FACIAL" },
  { name: "ACNE SCAR" },
  { name: "MOLE & BIRTH MARK REMOVAL" },
  { name: "SKIN BRIGHTENING" },
  { name: "TATTO REMOVAL" },
  { name: "WARTS REMOVAL" },
  { name: "ANTI AGEING LASER" },
  { name: "LASER HAIR REMOVAL" },
];

// Mapping treatment names to their PNG icons
const treatmentIconPNGMap = {
  "ADVANCED HYDRAFACIAL": hydrafacialIcon,
  ACNE: acneIcon,
  "SKIN BRIGHTENING": skinBrighteningIcon,
  "ANTI AGEING": antiAgeingIcon,
  YOUTH: youthIcon,
  "PRP FACE": prpFaceIcon,
  "CO2 FACIAL": co2FacialIcon,
  "ACNE SCAR": acneScarIcon,
  "MOLE & BIRTH MARK REMOVAL": moleBirthMarkIcon,
  "TATTO REMOVAL": tattoRemovalIcon,
  "WARTS REMOVAL": wartsRemovalIcon,
  "ANTI AGEING LASER": antiAgeingLaserIcon,
  "LASER HAIR REMOVAL": laserHairRemovalIcon,
};

// Mapping treatment names to their URLs with "advanced" prefix
const treatmentUrlMap = {
  "ADVANCED HYDRAFACIAL": "/advanced-hydrafacial-treatment",
  "ACNE": "/advanced-acne-treatment",
  "ANTI AGEING": "/advanced-anti-ageing-treatment",
  "YOUTH": "/advanced-youth-treatment",
  "PRP FACE": "/advanced-prp-face-treatment",
  "CO2 FACIAL": "/advanced-co2-facial-treatment",
  "ACNE SCAR": "/advanced-acne-scar-treatment",
  "MOLE & BIRTH MARK REMOVAL": "/advanced-mole-birth-mark-removal-treatment",
  "SKIN BRIGHTENING": "/advanced-skin-brightening-treatment",
  "TATTO REMOVAL": "/advanced-tatto-removal-treatment",
  "WARTS REMOVAL": "/advanced-warts-removal-treatment",
  "ANTI AGEING LASER": "/advanced-anti-ageing-laser-treatment",
  "LASER HAIR REMOVAL": "/advanced-laser-hair-removal-treatment",
};

// Location data for SEO purposes only
const locations = {
  tambaram: {
    name: "Tambaram",
    address: "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Tambaram, Chennai, Tamil Nadu 600045",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Chromepet, Pallavaram, Perungalathur",
    popularServices: [
      "CO2 Facial Treatment",
      "Carbon Dioxide Laser Therapy",
      "Skin Resurfacing",
      "Scar Reduction Treatment"
    ],
    specialties: "CO2 Facial & Skin Rejuvenation",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Tambaram+Chennai"
  },
  valasaravakkam: {
    name: "Valasaravakkam",
    address: "48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Porur, Alwarthirunagar, Virugambakkam",
    popularServices: [
      "Advanced CO2 Facial",
      "Wrinkle Reduction CO2",
      "Collagen Stimulation",
      "Facial Rejuvenation"
    ],
    specialties: "CO2 Treatments & Skin Renewal",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Valasaravakkam+Chennai"
  },
  gerugambakkam: {
    name: "Gerugambakkam",
    address: "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Kundrathur, Mangadu, Poonamallee",
    popularServices: [
      "Non-Invasive CO2 Treatment",
      "CO2 Skin Tightening",
      "Precision CO2 Therapy",
      "Professional CO2 Care"
    ],
    specialties: "Complete CO2 Facial Solutions",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Gerugambakkam+Chennai"
  },
  jayanagar: {
    name: "Jayanagar Bangalore",
    address: "Jayanagar, Bengaluru, Karnataka 560069",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Koramangala, BTM Layout, JP Nagar, Banashankari, Basavanagudi, Wilson Garden, Lalbagh",
    popularServices: [
      "Advanced CO2 Facial",
      "CO2 Laser Rejuvenation",
      "Carbon Dioxide Therapy",
      "CO2 Skin Treatment"
    ],
    specialties: "Advanced CO2 Facial & Dermatology Treatments",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Jayanagar+Bangalore"
  }
};

// Define the gallery images
const images = [
  { src: "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?q=80", alt: "Before and After CO2 Results" },
  { src: "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?q=80", alt: "CO2 Facial Procedure Close-Up" },
  { src: "https://images.unsplash.com/photo-1606206522398-de3bd05b1615?q=80", alt: "Advanced CO2 Equipment" },
];

function TreatmentNav() {
  const [activeTab, setActiveTab] = useState("CO2 FACIAL");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pathSegments = location.pathname.split("/");
    const treatmentPath = pathSegments[pathSegments.length - 1];
    
    const currentTreatment = Object.entries(treatmentUrlMap).find(
      ([name, url]) => url.includes(treatmentPath)
    );
    
    if (currentTreatment) {
      setActiveTab(currentTreatment[0]);
    }
  }, [location.pathname]);

  const renderTreatmentIcon = (name) => {
    return treatmentIconPNGMap[name] ? (
      <img
        src={treatmentIconPNGMap[name]}
        alt={name}
        style={{ width: "100px", height: "100px" }}
      />
    ) : null;
  };

  const handleCardClick = (name) => {
    setActiveTab(name);
    navigate(treatmentUrlMap[name]);
  };

  return (
    <div className="ads-treatment-nav-container">
      <h2>Innovative CO2 Facial Solutions</h2>
      <div className="ads-treatment-nav-cards">
        {treatments.map(({ name }) => (
          <div
            key={name}
            className={`ads-treatment-nav-card ${activeTab === name ? "active" : ""}`}
            onClick={() => handleCardClick(name)}
          >
            <div className="ads-card-icon">
              {renderTreatmentIcon(name)}
            </div>
            <div className="ads-card-title">{name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function CO2Facial() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [visibleGalleryImages, setVisibleGalleryImages] = useState([0, 1, 2]);
  
  // SEO and document setup
  useEffect(() => {
    // Enhanced SEO title with specific location keywords
    document.title =
      "Best CO2 Facial Treatment in Chennai, Bangalore | Carbon Dioxide Laser Therapy Tamil Nadu Karnataka - H-Cura Multispecialty";
    
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Best CO2 facial treatment in Chennai, Bangalore. Advanced carbon dioxide laser therapy, skin resurfacing, and wrinkle reduction solutions. Professional dermatological services at H-Cura clinic locations across Chennai Tamil Nadu and Bangalore Karnataka including Tambaram, Valasaravakkam, Gerugambakkam, Jayanagar areas."
      );
    }
    
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "CO2 facial treatment Chennai, carbon dioxide laser Bangalore, CO2 facial clinic Tamil Nadu, dermatologist Karnataka, CO2 skin resurfacing Chennai Bangalore, CO2 facial specialist Tamil Nadu Karnataka, best CO2 clinic Chennai Bangalore, CO2 treatment near me, CO2 laser therapy Tambaram Valasaravakkam Gerugambakkam Jayanagar, dermatology clinic Chennai Bangalore, carbon dioxide treatment Tamil Nadu Karnataka, CO2 wrinkle reduction Chennai Bangalore, CO2 scar treatment specialist Chromepet Pallavaram Perungalathur Koramangala BTM Layout JP Nagar, advanced CO2 facial Porur Alwarthirunagar Virugambakkam Banashankari Basavanagudi, CO2 skin tightening Kundrathur Mangadu Poonamallee Wilson Garden Lalbagh, CO2 facial rejuvenation Chennai Bangalore, CO2 collagen stimulation Tamil Nadu Karnataka, CO2 skin renewal Chennai Bangalore, precision CO2 therapy Tamil Nadu Karnataka, CO2 pigmentation removal Tambaram Jayanagar, CO2 age spot removal Valasaravakkam Koramangala, non invasive CO2 Gerugambakkam BTM Layout, professional CO2 care Chennai Bangalore, advanced CO2 facial Tamil Nadu Karnataka, CO2 anti aging therapy Chennai Bangalore, CO2 skin improvement Tamil Nadu Karnataka, CO2 wrinkle treatment Chennai Bangalore, CO2 facial doctor Tamil Nadu Karnataka, CO2 treatment center Chennai Bangalore, dermatology Chennai Bangalore, CO2 skincare clinic Tamil Nadu Karnataka, CO2 facial consultation Chennai Bangalore, CO2 skin analysis Tamil Nadu Karnataka, CO2 treatment prevention Chennai Bangalore, CO2 skin health Tamil Nadu Karnataka, dermatological CO2 treatment Chennai Bangalore, cosmetic CO2 dermatology Tamil Nadu Karnataka, medical CO2 skincare Chennai Bangalore, professional CO2 facial treatment Tamil Nadu Karnataka, CO2 skin wellness Chennai Bangalore, CO2 dermatology services Tamil Nadu Karnataka, CO2 facial treatment Tambaram Gandhi Road Jayanagar, CO2 clinic Valasaravakkam Krishnamachari Nagar Koramangala, CO2 dermatologist Gerugambakkam Ramachandra Nagar BTM Layout, CO2 facial doctor Chromepet Pallavaram JP Nagar Banashankari, CO2 skin treatment Porur Alwarthirunagar Basavanagudi Wilson Garden, CO2 treatment clinic Virugambakkam Kundrathur Lalbagh, CO2 rejuvenation treatment Mangadu Poonamallee Bangalore"
      );
    }

    // Add structured data for local business with specific locations
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "MedicalBusiness",
      "name": "H-Cura Multispeciality Clinic",
      "description": "Advanced CO2 facial and carbon dioxide laser treatment clinic offering professional dermatological services across Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry",
      "url": "https://www.h-cura.com/advanced-co2-facial-treatment",
      "telephone": "+91 88700 01377",
      "priceRange": "₹₹",
      "address": [
        {
          "@type": "PostalAddress",
          "streetAddress": "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram",
          "addressLocality": "Tambaram",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600045",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "48, 1st Main Rd, Krishnamachari Nagar",
          "addressLocality": "Valasaravakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600116",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony",
          "addressLocality": "Gerugambakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600128",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Jayanagar",
          "addressLocality": "Jayanagar",
          "addressRegion": "Bengaluru, Karnataka",
          "postalCode": "560069",
          "addressCountry": "IN"
        }
      ],
      "areaServed": [
        {
          "@type": "State",
          "name": "Tamil Nadu"
        },
        {
          "@type": "State",
          "name": "Karnataka"
        },
        {
          "@type": "State",
          "name": "Pondicherry"
        },
        {
          "@type": "City",
          "name": "Chennai"
        },
        {
          "@type": "City",
          "name": "Bangalore"
        },
        {
          "@type": "City",
          "name": "Bengaluru"
        },
        {
          "@type": "City",
          "name": "Pondicherry"
        },
        {
          "@type": "City",
          "name": "Puducherry"
        },
        // Chennai Areas
        {
          "@type": "City",
          "name": "Tambaram"
        },
        {
          "@type": "City",
          "name": "Valasaravakkam"
        },
        {
          "@type": "City",
          "name": "Gerugambakkam"
        },
        {
          "@type": "City",
          "name": "Chromepet"
        },
        {
          "@type": "City",
          "name": "Pallavaram"
        },
        {
          "@type": "City",
          "name": "Perungalathur"
        },
        {
          "@type": "City",
          "name": "Porur"
        },
        {
          "@type": "City",
          "name": "Alwarthirunagar"
        },
        {
          "@type": "City",
          "name": "Virugambakkam"
        },
        {
          "@type": "City",
          "name": "Kundrathur"
        },
        {
          "@type": "City",
          "name": "Mangadu"
        },
        {
          "@type": "City",
          "name": "Poonamallee"
        },
        // Bangalore Areas
        {
          "@type": "City",
          "name": "Jayanagar"
        },
        {
          "@type": "City",
          "name": "Koramangala"
        },
        {
          "@type": "City",
          "name": "BTM Layout"
        },
        {
          "@type": "City",
          "name": "JP Nagar"
        },
        {
          "@type": "City",
          "name": "Banashankari"
        },
        {
          "@type": "City",
          "name": "Basavanagudi"
        },
        {
          "@type": "City",
          "name": "Wilson Garden"
        },
        {
          "@type": "City",
          "name": "Lalbagh"
        }
      ],
      "serviceArea": [
        // Tamil Nadu - Chennai Areas
        "Chennai", "Tamil Nadu", "Tambaram", "Valasaravakkam", "Gerugambakkam", "Chromepet", "Pallavaram", "Perungalathur",
        "Porur", "Alwarthirunagar", "Virugambakkam", "Kundrathur", "Mangadu", "Poonamallee", "Gandhi Road", "Krishnamachari Nagar", "Ramachandra Nagar",
        
        // Karnataka - Bangalore Areas
        "Bangalore", "Bengaluru", "Karnataka", "Jayanagar", "Koramangala", "BTM Layout", "JP Nagar", "Banashankari", "Basavanagudi", "Wilson Garden", "Lalbagh"
      ],
      "medicalSpecialty": [
        "Dermatology",
        "Cosmetic Dermatology", 
        "CO2 Facial Treatment",
        "Carbon Dioxide Laser Therapy",
        "Skin Resurfacing",
        "Wrinkle Reduction",
        "Scar Treatment",
        "Facial Rejuvenation"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "CO2 Facial Treatment Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "Advanced CO2 Facial Treatment"
            }
          },
          {
            "@type": "Offer", 
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "Carbon Dioxide Laser Therapy"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "CO2 Skin Resurfacing"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "CO2 Wrinkle Reduction"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "CO2 Scar Treatment"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "CO2 Facial Rejuvenation"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "CO2 Collagen Stimulation"
            }
          }
        ]
      },
      "openingHours": "Mo-Su 10:00-20:00",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "1250"
      },
      "review": [
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Priya Sharma"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Excellent CO2 facial treatment at H-Cura Jayanagar. Professional staff and amazing results."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Rajesh Kumar"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Best CO2 skin resurfacing treatment in Chennai Tambaram. Highly recommend H-Cura clinic."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Meera Nair"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Amazing CO2 facial treatment results at H-Cura. Professional and caring staff."
        }
      ]
    };

    // Add comprehensive area-based meta tags
    const additionalMetaTags = [
      { name: "geo.region", content: "IN-TN" },
      { name: "geo.region", content: "IN-KA" },
      { name: "geo.region", content: "IN-PY" },
      { name: "geo.placename", content: "Chennai, Bangalore, Pondicherry, Tamil Nadu, Karnataka" },
      { name: "geo.position", content: "13.0827;80.2707" }, // Chennai coordinates
      { name: "geo.position", content: "12.9716;77.5946" }, // Bangalore coordinates
      { name: "geo.position", content: "11.9416;79.8083" }, // Pondicherry coordinates
      { name: "ICBM", content: "13.0827, 80.2707" },
      { name: "ICBM", content: "12.9716, 77.5946" },
      { name: "ICBM", content: "11.9416, 79.8083" },
      { property: "og:title", content: "Best CO2 Facial Treatment Chennai Bangalore Pondicherry | H-Cura Multispecialty Clinic" },
      { property: "og:description", content: "Advanced CO2 facial treatment and carbon dioxide laser therapy solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry. Professional dermatological services for youthful, radiant skin at H-Cura clinics across 100+ locations." },
      { property: "og:url", content: "https://www.h-cura.com/advanced-co2-facial-treatment" },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_IN" },
      { property: "og:site_name", content: "H-Cura Multispecialty Clinic" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Best CO2 Facial Treatment Chennai Bangalore Pondicherry | H-Cura" },
      { name: "twitter:description", content: "Advanced CO2 facial treatment and carbon dioxide laser therapy solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry." },
      { name: "robots", content: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" },
      { name: "googlebot", content: "index, follow" },
      { name: "bingbot", content: "index, follow" },
      { name: "language", content: "English" },
      { name: "distribution", content: "global" },
      { name: "rating", content: "general" },
      { name: "revisit-after", content: "7 days" },
      { name: "author", content: "H-Cura Multispecialty Clinic" },
      { name: "classification", content: "Medical, Healthcare, Dermatology" },
      { name: "coverage", content: "Worldwide" },
      { name: "subject", content: "CO2 Facial Treatment, Carbon Dioxide Laser Therapy, Dermatology" },
      { name: "copyright", content: "H-Cura Multispecialty Clinic" },
      { name: "locality", content: "Chennai, Bangalore, Pondicherry" },
      { name: "region", content: "Tamil Nadu, Karnataka, Pondicherry" },
      { name: "country", content: "India" }
    ];

    additionalMetaTags.forEach(tag => {
      const existingTag = document.querySelector(`meta[${tag.name ? 'name' : 'property'}="\${tag.name || tag.property}"]`);
      if (existingTag) {
        existingTag.setAttribute("content", tag.content);
      } else {
        const metaTag = document.createElement("meta");
        if (tag.name) metaTag.setAttribute("name", tag.name);
        if (tag.property) metaTag.setAttribute("property", tag.property);
        metaTag.setAttribute("content", tag.content);
        document.head.appendChild(metaTag);
      }
    });

    // Add structured data script
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-co2-facial-treatment"
      );
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-co2-facial-treatment"
      );
      document.head.appendChild(canonicalLink);
    }

    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }

    // Add breadcrumb structured data
    const breadcrumbData = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://www.h-cura.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Treatments",
          "item": "https://www.h-cura.com/treatments"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "CO2 Facial Treatment",
          "item": "https://www.h-cura.com/advanced-co2-facial-treatment"
        }
      ]
    };

    const breadcrumbScript = document.createElement('script');
    breadcrumbScript.type = 'application/ld+json';
    breadcrumbScript.textContent = JSON.stringify(breadcrumbData);
    document.head.appendChild(breadcrumbScript);

    // Add FAQ structured data
    const faqData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What areas does H-Cura serve for CO2 facial treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "H-Cura provides CO2 facial treatment services across Chennai Tamil Nadu (100+ areas including Tambaram, Valasaravakkam, T Nagar, Anna Nagar), Bangalore Karnataka (100+ areas including Jayanagar, Koramangala, BTM Layout, Indiranagar), and Pondicherry (50+ areas including White Town, Lawspet, Auroville)."
          }
        },
        {
          "@type": "Question",
          "name": "What types of CO2 facial treatments are available?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We offer Advanced CO2 Facial Treatment, Carbon Dioxide Laser Therapy, CO2 Skin Resurfacing, CO2 Wrinkle Reduction, CO2 Scar Treatment, CO2 Facial Rejuvenation, and CO2 Collagen Stimulation across all our Chennai, Bangalore, and Pondicherry locations."
          }
        },
        {
          "@type": "Question",
          "name": "How can I book an appointment for CO2 facial treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can book an appointment by calling +91 88700 01377 or visiting any of our clinics in Chennai (Tambaram, Valasaravakkam, Gerugambakkam), Bangalore (Jayanagar), or Pondicherry locations. We are open Monday to Sunday: 10:00 AM - 8:00 PM."
          }
        }
      ]
    };

    const faqScript = document.createElement('script');
    faqScript.type = 'application/ld+json';
    faqScript.textContent = JSON.stringify(faqData);
    document.head.appendChild(faqScript);

    // Add preconnect for performance
    const performanceLinks = [
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: "" },
      { rel: "preconnect", href: "https://images.unsplash.com" },
      { rel: "dns-prefetch", href: "https://www.google-analytics.com" },
      { rel: "dns-prefetch", href: "https://www.googletagmanager.com" },
      { rel: "dns-prefetch", href: "https://maps.googleapis.com" },
      { rel: "dns-prefetch", href: "https://fonts.googleapis.com" },
      { rel: "dns-prefetch", href: "https://cdnjs.cloudflare.com" }
    ];

    performanceLinks.forEach(link => {
      const existingLink = document.querySelector(`link[href="${link.href}"]`);
      if (!existingLink) {
        const linkElement = document.createElement("link");
        linkElement.setAttribute("rel", link.rel);
        linkElement.setAttribute("href", link.href);
        if (link.crossorigin !== undefined) {
          linkElement.setAttribute("crossorigin", link.crossorigin);
        }
        document.head.appendChild(linkElement);
      }
    });

    // Add hreflang tags for regional targeting
    const hreflangTags = [
      { rel: "alternate", hreflang: "en-IN", href: "https://www.h-cura.com/advanced-co2-facial-treatment" },
      { rel: "alternate", hreflang: "en", href: "https://www.h-cura.com/advanced-co2-facial-treatment" }
    ];

    hreflangTags.forEach(tag => {
      const existingHreflang = document.querySelector(`link[hreflang="${tag.hreflang}"]`);
      if (!existingHreflang) {
        const hreflangLink = document.createElement("link");
        hreflangLink.setAttribute("rel", tag.rel);
        hreflangLink.setAttribute("hreflang", tag.hreflang);
        hreflangLink.setAttribute("href", tag.href);
        document.head.appendChild(hreflangLink);
      }
    });

    // Cleanup function
    return () => {
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => {
        if (script.textContent.includes('H-Cura Multispeciality Clinic')) {
          script.remove();
        }
      });
    };
  }, []);

  useEffect(() => {
    const steps = document.querySelectorAll(".ads-process-step");
    steps.forEach((step, index) => {
      step.style.setProperty("--index", index);
      step.style.opacity = "1";
    });
  }, []);

  const openModal = (image) => {
    const index = images.findIndex(img => img.src === image.src);
    setCurrentImageIndex(index);
    setModalImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalImage(null);
  };

  const navigatePrevious = (e) => {
    e.stopPropagation();
    const newIndex = (currentImageIndex - 1 + images.length) % images.length;
    setCurrentImageIndex(newIndex);
    setModalImage(images[newIndex]);
  };

  const navigateNext = (e) => {
    e.stopPropagation();
    const newIndex = (currentImageIndex + 1) % images.length;
    setCurrentImageIndex(newIndex);
    setModalImage(images[newIndex]);
  };

  const navigateGalleryPrev = () => {
    if (visibleGalleryImages[0] > 0) {
      const newVisibleImages = visibleGalleryImages.map(idx => idx - 1);
      setVisibleGalleryImages(newVisibleImages);
    }
  };

  const navigateGalleryNext = () => {
    if (visibleGalleryImages[visibleGalleryImages.length - 1] < images.length - 1) {
      const newVisibleImages = visibleGalleryImages.map(idx => idx + 1);
      setVisibleGalleryImages(newVisibleImages);
    }
  };

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isModalOpen) return;
      
      if (e.key === 'ArrowLeft') {
        navigatePrevious(e);
      } else if (e.key === 'ArrowRight') {
        navigateNext(e);
      } else if (e.key === 'Escape') {
        closeModal();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isModalOpen, currentImageIndex]);

  return (
    <div className="ads-wrapper">
      <TreatmentNav />
      <section
        className="ads-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${heroImage})`,
        }}
      >
        <div className="ads-hero-content">
          <h1 className="ads-hero-title">
            Innovative CO2 Facial Solutions for Radiant Skin
          </h1>
          <p className="ads-hero-text">
            Experience cutting-edge CO2 facial therapies designed to rejuvenate,
            and transform your skin.
          </p>
          <Link
            to="/bookconsultation"
            style={{ textDecoration: "none" }}
            className="ads-cta-button"
          >
            Book Consultation
          </Link>
        </div>
      </section>

      <section className="ads-treatment-section" id="treatments">
        <div className="ads-treatment-container">
          <div className="ads-treatment-nav">
            <h2>Revitalize Your Skin with CO2 Facial Treatment</h2>
            <p className="ads-nav-description">
              Our CO2 facial treatment combines advanced technology with nourishing
              ingredients for optimal skin health.
            </p>

            <ul className="ads-treatment-list">
              <li className="ads-treatment-item">
                <strong>CARBON DIOXIDE LASER THERAPY</strong>
                <p>Advanced carbon dioxide laser for skin resurfacing.</p>
                <ul className="ads-treatment-details">
                  <li>Improves Skin Texture and Tone</li>
                  <li>Reduces Fine Lines and Wrinkles</li>
                  <li>Stimulates Collagen Production</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>CO2 SKIN RESURFACING</strong>
                <p>Precision CO2 laser for deep skin rejuvenation.</p>
                <ul className="ads-treatment-details">
                  <li>Advanced Skin Resurfacing</li>
                  <li>Reduces Deep Wrinkles</li>
                  <li>Improves Skin Elasticity</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>CO2 WRINKLE REDUCTION</strong>
                <p>Targeted CO2 treatment for fine lines and wrinkles.</p>
                <ul className="ads-treatment-details">
                  <li>Smooths Expression Lines</li>
                  <li>Reduces Deep Wrinkles</li>
                  <li>Prevents Future Aging Signs</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>CO2 SCAR TREATMENT</strong>
                <p>Effective CO2 laser for acne scars and spots.</p>
                <ul className="ads-treatment-details">
                  <li>Reduces Acne Scars</li>
                  <li>Improves Skin Texture</li>
                  <li>Evens Skin Tone</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>CO2 COLLAGEN STIMULATION</strong>
                <p>Stimulates natural collagen production for firmer skin.</p>
                <ul className="ads-treatment-details">
                  <li>Enhances Skin Elasticity</li>
                  <li>Promotes Skin Firmness</li>
                  <li>Boosts Youthful Appearance</li>
                </ul>
              </li>
            </ul>
            <p className="ads-treatment-description-text">
              Our CO2 Facial treatments are customized for each individual's skin type
              and concerns.
            </p>
            <p className="ads-treatment-extra-info">
              Book a consultation today to discover the benefits of CO2 Facial.
            </p>
          </div>

          <div className="ads-treatment-content">
            <h3>Innovative CO2 Facial Treatment Overview</h3>
            <div className="ads-treatment-info">
              <div className="ads-treatment-images">
                <img
                  src={heroImage1}
                  alt="Innovative CO2 Facial Treatment Process"
                  className="ads-main-treatment-image"
                />
                <div className="ads-gallery-container">
                  <button 
                    className="ads-gallery-nav ads-gallery-prev ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector('.ads-treatment-gallery');
                      if (gallery) {
                        gallery.scrollBy({ left: -gallery.clientWidth * 0.8, behavior: 'smooth' });
                      }
                      navigateGalleryPrev();
                    }}
                    aria-label="Previous image"
                    style={{display: visibleGalleryImages[0] > 0 ? 'block' : 'none'}}
                  >
                    &#10094;
                  </button>
                  <button 
                    className="ads-gallery-nav ads-gallery-next ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector('.ads-treatment-gallery');
                      if (gallery) {
                        gallery.scrollBy({ left: gallery.clientWidth * 0.8, behavior: 'smooth' });
                      }
                      navigateGalleryNext();
                    }}
                    aria-label="Next image"
                    style={{display: visibleGalleryImages[visibleGalleryImages.length - 1] < images.length - 1 ? 'block' : 'none'}}
                  >
                    &#10095;
                  </button>
                </div>
                <div className="ads-gallery-dots">
                  {images.map((_, index) => (
                    <span 
                      key={index} 
                      className={`ads-gallery-dot ${visibleGalleryImages.includes(index) ? 'active' : ''}`}
                      onClick={() => {
                        const start = Math.max(0, index - 1);
                        const end = Math.min(images.length - 1, index + 1);
                        const newVisible = [];
                        for (let i = start; i <= end; i++) {
                          newVisible.push(i);
                        }
                        setVisibleGalleryImages(newVisible);
                      }}
                    ></span>
                  ))}
                </div>
              </div>

              <div className="ads-treatment-description">
                <h4>Empowering Innovative CO2 Facial Solutions</h4>
                <div className="ads-treatment-intro">
                  <span className="ads-highlight-tag">  INNOVATIVE CO2 FACIAL</span>
                  <p className="ads-lead-text">
                    Our breakthrough CO2 facial treatments combine advanced technology,
                    precision targeting, and expert care to rejuvenate your skin.
                  </p>
                </div>

                <div className="ads-key-benefits">
                  <h5>Transformative Benefits of Our CO2 Facial Treatments</h5>
                  <p>Enjoy benefits such as:</p>
                  <ul>
                    <li>
                      <span className="ads-benefit-icon">
                        <img src={nonInvasiveIcon} alt="Collagen Boost" />
                      </span>{" "}
                      <strong>Collagen Boost</strong>
                      <p>Stimulates natural collagen production for firmer skin</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={enhancedHydrationIcon}
                          alt="Glowing and Shining"
                        />
                      </span>{" "}
                      <strong>Glowing and Shining</strong>
                      <p>Enhanced hydration and brightness for radiant skin</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={skinRenewalIcon}
                          alt="Youthful Look"
                        />
                      </span>{" "}
                      <strong>Young Look</strong>
                      <p>Improves skin texture and tone for a younger appearance</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={deepCleansingIcon}
                          alt="Non-Invasive Treatment"
                        />
                      </span>{" "}
                      <strong>Non-Invasive Treatment</strong>
                      <p>
                        Achieve remarkable results with minimal downtime and
                        maximum comfort.
                      </p>
                    </li>
                  </ul>
                </div>

                <div className="ads-treatment-highlights">
                  <div className="ads-highlight-box">
                    <h5>Client Satisfaction Rate</h5>
                    <p>98%</p>
                    <span className="ads-subtitle">Happy Clients</span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Session Duration</h5>
                    <p>45 mins</p>
                    <span className="ads-subtitle">Per Treatment</span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Minimal Downtime</h5>
                    <p>Immediate Results</p>
                    <span className="ads-subtitle">Quick Recovery</span>
                  </div>
                </div>

                <Link to="/bookconsultation" style={{ textDecoration: "none" }}>
                  <button className="ads-book-treatment-btn">
                    Schedule Your Consultation
                    <span className="ads-btn-icon">→</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ads-benefits-section">
        <div className="ads-benefits-header">
          <span className="ads-section-tag">Why Choose Us</span>
          <h2>Experience Excellence with H-Cura Multispeciality clinic</h2>
          <p className="ads-section-subtitle">
            Our advanced CO2 facial treatments combine clinical expertise with innovative
            technology to restore your skin's natural beauty.
          </p>
        </div>
        <div className="ads-benefits-grid">
          {[
            {
              icon: "🔬",
              title: "State-of-the-Art Technology",
              desc: "We deploy the latest in CO2 facial treatment technology for precise and effective results.",
              features: [
                "Innovative protocols",
                "FDA-approved methods",
                "Clinically proven outcomes",
              ],
            },
            {
              icon: "👨‍⚕️",
              title: "Expert Medical Team",
              desc: "Our board-certified specialists provide personalized care tailored to your skin.",
              features: [
                "Highly experienced professionals",
                "Individual consultations",
                "Focused attention to detail",
              ],
            },
            {
              icon: "🎯",
              title: "Customized Therapy",
              desc: "Every treatment plan is designed specifically for your skin type and CO2 facial concerns.",
              features: [
                "Tailored sessions",
                "Ongoing progress monitoring",
                "Optimized treatment frequency",
              ],
            },
            {
              icon: "✨",
              title: "Natural-Looking Results",
              desc: "Achieve visible, natural skin improvement with our gentle, effective CO2 facial treatments.",
              features: [
                "Subtle enhancements",
                "Long-lasting benefits",
                "Effortless aesthetics",
              ],
            },
            {
              icon: "🛡️",
              title: "Safety First",
              desc: "We maintain the highest standards of safety and hygiene in our CO2 facial treatment facilities.",
              features: [
                "Medical-grade environment",
                "Strict protocols",
                "Patient-centric care",
              ],
            },
            {
              icon: "💯",
              title: "Proven Success",
              desc: "Join thousands of happy clients who have transformed their skin with our CO2 facial solutions.",
              features: [
                "Over 5000 satisfied clients",
                "Remarkable clinical outcomes",
                "Consistently high success rates",
              ],
            },
          ].map((benefit, index) => (
            <div className="ads-benefit-card" key={index}>
              <div className="ads-benefit-icon">{benefit.icon}</div>
              <div className="ads-benefit-content">
                <h3>{benefit.title}</h3>
                <p>{benefit.desc}</p>
                <ul className="ads-feature-list">
                  {benefit.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="ads-process-section" id="process">
        <div className="ads-process-header">
          <span className="ads-process-tag">Our Process</span>
          <h2>Your Journey to Radiant, Rejuvenated Skin with CO2 Facial</h2>
          <p className="ads-process-subtitle">
            Follow our comprehensive 4-step approach for sustainable CO2 facial
            and skin rejuvenation.
          </p>
        </div>
        <div className="ads-process-timeline">
          {[
            {
              step: "01",
              title: "In-Depth Consultation",
              desc: "Kick off your journey with a thorough consultation to assess your skin and CO2 facial needs.",
              details: [
                "Detailed skin analysis",
                "Personal health review",
                "Customized treatment roadmap",
                "Expectation setting",
              ],
              icon: "🔍",
            },
            {
              step: "02",
              title: "Tailored Treatment Planning",
              desc: "Our specialists design a personalized CO2 facial treatment plan just for you.",
              details: [
                "Individualized regimen design",
                "Session scheduling",
                "Lifestyle coaching",
              ],
              icon: "📋",
            },
            {
              step: "03",
              title: "Expert CO2 Facial Session",
              desc: "Experience our precise techniques for targeted and effective CO2 facial treatment.",
              details: [
                "Sterile preparation",
                "Precise application",
                "Targeted skin care",
                "Comfort-focused procedure",
              ],
              icon: "💉",
            },
            {
              step: "04",
              title: "Comprehensive Aftercare",
              desc: "Benefit from our dedicated follow-up care ensuring your skin remains at its best.",
              details: [
                "Routine progress reviews",
                "Adaptive treatment adjustments",
                "Maintenance plans",
                "Long-term support",
              ],
              icon: "📈",
            },
          ].map((process, index) => (
            <div className="ads-process-step" key={index}>
              <div className="ads-step-container">
                <div className="ads-step-number-container">
                  <div className="ads-step-number">{process.step}</div>
                  <div className="ads-step-icon">{process.icon}</div>
                </div>
                <div className="ads-step-content">
                  <h3>{process.title}</h3>
                  <p className="ads-step-description">{process.desc}</p>
                  <ul className="ads-step-details">
                    {process.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                </div>
              </div>
              {index < 3 && <div className="ads-connector-line"></div>}
            </div>
          ))}
        </div>
      </section>

      {/* Hidden SEO Content - Not visible to users but crawlable by search engines */}
      <div style={{ display: 'none' }}>
        <h2>Best CO2 Facial Treatment Services in Chennai Tamil Nadu and Bangalore Karnataka - H-Cura Locations</h2>
        
        <h3>CO2 Facial Treatment in Tambaram Chennai - Gandhi Road Location</h3>
        <p>
          Advanced CO2 facial treatment services at our Tambaram clinic located at Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Chennai, Tamil Nadu 600045. 
          Serving patients from Chromepet, Pallavaram, Perungalathur areas with CO2 Facial Treatment, Carbon Dioxide Laser Therapy, Skin Resurfacing, Scar Reduction Treatment. 
          Specializing in CO2 Facial & Skin Rejuvenation. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best CO2 facial treatment Tamil Nadu, CO2 facial specialist Chennai, CO2 dermatologist Tambaram, CO2 clinic Chromepet, CO2 treatment Pallavaram, CO2 skin resurfacing Perungalathur.
        </p>
        
        <h3>CO2 Facial Clinic in Valasaravakkam Chennai - Krishnamachari Nagar</h3>
        <p>
          Professional CO2 facial services at our Valasaravakkam branch located at 48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116. 
          Serving Porur, Alwarthirunagar, Virugambakkam communities with Advanced CO2 Facial, Wrinkle Reduction CO2, Collagen Stimulation, Facial Rejuvenation. 
          Specializing in CO2 Treatments & Skin Renewal. Phone: +91 88700 01377. Hours: Monday to Sunday: 10:00 AM - 8:00 PM.
          CO2 facial treatment Valasaravakkam, CO2 clinic Porur, CO2 dermatologist Alwarthirunagar, CO2 facial specialist Virugambakkam, CO2 skin rejuvenation Chennai Tamil Nadu.
        </p>
        
        <h3>Complete CO2 Facial Solutions in Gerugambakkam Chennai - Ramachandra Nagar</h3>
        <p>
          Comprehensive CO2 facial treatment services at our Gerugambakkam clinic at Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128. 
          Providing services to Kundrathur, Mangadu, Poonamallee residents with Non-Invasive CO2 Treatment, CO2 Skin Tightening, Precision CO2 Therapy, Professional CO2 Care. 
          Offering Complete CO2 Facial Solutions. Call: +91 88700 01377. Timing: Monday to Sunday: 10:00 AM - 8:00 PM.
          CO2 facial treatment Gerugambakkam, CO2 clinic Kundrathur, CO2 dermatologist Mangadu, CO2 facial specialist Poonamallee, CO2 skin rejuvenation Chennai Tamil Nadu.
        </p>

        <h3>Advanced CO2 Facial Treatment in Jayanagar Bangalore Karnataka</h3>
        <p>
          Premier CO2 facial and carbon dioxide laser treatment services at our Jayanagar Bangalore clinic located at Jayanagar, Bengaluru, Karnataka 560069. 
          Serving patients from Koramangala, BTM Layout, JP Nagar, Banashankari, Basavanagudi, Wilson Garden, Lalbagh areas with Advanced CO2 Facial, CO2 Laser Rejuvenation, Carbon Dioxide Therapy, CO2 Skin Treatment. 
          Specializing in Advanced CO2 Facial & Dermatology Treatments. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best CO2 facial treatment Bangalore, CO2 facial specialist Karnataka, CO2 dermatologist Jayanagar, CO2 clinic Koramangala, CO2 treatment BTM Layout, carbon dioxide laser JP Nagar, 
          CO2 facial doctor Banashankari, CO2 skin rejuvenation Basavanagudi, CO2 dermatology Wilson Garden, CO2 facial treatment Lalbagh, CO2 clinic Bangalore Karnataka, CO2 facial specialist Bengaluru.
        </p>

        <h3>Comprehensive Bangalore Karnataka Service Areas</h3>
        <p>
          H-Cura Multispeciality Clinic Bangalore provides CO2 facial treatment and carbon dioxide laser therapy services across Bangalore Karnataka including Jayanagar, Koramangala, BTM Layout, JP Nagar, 
          Banashankari, Basavanagudi, Wilson Garden, Lalbagh, Indiranagar, Whitefield, Electronic City, HSR Layout, Marathahalli, Bannerghatta Road, Hebbal, Yeshwantpur,
          Rajajinagar, Malleshwaram, Sadashivanagar, RT Nagar, Yelahanka, Kengeri, Vijayanagar, Nagarbhavi areas in Karnataka.
          CO2 facial treatment Bangalore, carbon dioxide laser Karnataka, CO2 dermatologist Bengaluru, CO2 facial clinic Bangalore, CO2 facial specialist Karnataka, skin resurfacing treatment Bangalore, 
          wrinkle reduction CO2 Karnataka, scar treatment CO2 Bangalore, collagen stimulation CO2 Karnataka, facial rejuvenation CO2 Bangalore, skin tightening CO2 Karnataka.
        </p>

        <h3>Chennai Tamil Nadu Service Areas Coverage</h3>
        <p>
          H-Cura Multispeciality Clinic Chennai provides CO2 facial treatment and carbon dioxide laser therapy services across Chennai Tamil Nadu including Tambaram East, Tambaram West, Chromepet, Pallavaram, 
          Perungalathur, Selaiyur, Chitlapakkam, Valasaravakkam, Porur, Alwarthirunagar, Virugambakkam, Ramapuram, Mugalivakkam, Gerugambakkam, Kundrathur, 
          Mangadu, Poonamallee, Nazarethpet, Thirumazhisai areas in Tamil Nadu.
          CO2 facial treatment Chennai, carbon dioxide laser Tamil Nadu, CO2 dermatologist Chennai, CO2 facial clinic Tamil Nadu, CO2 facial specialist Chennai, skin resurfacing treatment Tamil Nadu.
        </p>

        <h3>Advanced CO2 Facial Treatments Available Across Chennai Tamil Nadu and Bangalore Karnataka</h3>
        <p>
          Our Chennai Tamil Nadu and Bangalore Karnataka locations offer comprehensive CO2 facial treatment including Advanced CO2 Facial Treatment, Carbon Dioxide Laser Therapy, CO2 Skin Resurfacing, 
          CO2 Wrinkle Reduction, CO2 Scar Treatment, CO2 Facial Rejuvenation, CO2 Collagen Stimulation, 
          Non-Invasive CO2 Treatment, and Precision CO2 Facial services.
          Best CO2 facial treatment Chennai Bangalore, CO2 facial specialist Tamil Nadu Karnataka, CO2 dermatologist Chennai Bangalore, CO2 facial clinic Tamil Nadu Karnataka.
        </p>

        <h3>Expert CO2 Facial Dermatology Team Chennai Tamil Nadu Bangalore Karnataka</h3>
        <p>
          Board-certified CO2 facial dermatologists and CO2 facial specialists providing personalized CO2 facial treatment solutions across Tambaram Gandhi Road Chennai, 
          Valasaravakkam Krishnamachari Nagar Chennai, Gerugambakkam Ramachandra Nagar Chennai, and Jayanagar Bangalore locations in Tamil Nadu and Karnataka.
          CO2 facial specialist Chennai Bangalore, CO2 dermatologist Tamil Nadu Karnataka, CO2 facial doctor Chennai Bangalore, CO2 treatment expert Tamil Nadu Karnataka.
        </p>

        <h3>SEO Keywords for Google Ranking</h3>
        <p>
          CO2 facial treatment near me, carbon dioxide laser near me, CO2 dermatologist near me, CO2 facial clinic near me, CO2 skin resurfacing near me, best CO2 facial treatment, 
          professional CO2 facial, CO2 facial doctor, CO2 skin clinic, CO2 dermatology clinic, carbon dioxide laser therapy, CO2 wrinkle reduction, CO2 scar treatment, CO2 collagen stimulation, 
          CO2 facial rejuvenation, non invasive CO2 treatment, precision CO2 therapy, CO2 skin tightening, CO2 pigmentation removal, CO2 age spot removal, 
          cosmetic CO2 dermatology, medical CO2 skincare, CO2 skin health, CO2 facial consultation, CO2 skin analysis, CO2 treatment prevention, dermatological CO2 treatment, 
          CO2 skin wellness, CO2 facial therapy, CO2 skin problem solutions, CO2 wrinkle removal, CO2 skin lifting, CO2 face lifting, 
          CO2 facial specialist doctor, professional CO2 facial care, advanced CO2 facial treatment, innovative CO2 facial solutions, CO2 skin transformation, 
          youthful CO2 facial treatment, radiant CO2 facial therapy, CO2 skin renewal, CO2 facial management, CO2 pigmentation removal, CO2 age spot removal, 
          non-invasive CO2 facial treatment, safe CO2 facial treatment, effective CO2 facial care, proven CO2 facial solutions, personalized CO2 facial treatment, 
          customized CO2 facial therapy, expert CO2 facial care, quality CO2 dermatology services, trusted CO2 facial clinic, reliable CO2 facial treatment, 
          affordable CO2 facial care, convenient CO2 dermatology, accessible CO2 facial treatment, comprehensive CO2 facial solutions.
        </p>
      </div>

      {/* Modal for Image Viewing with Navigation */}
      {isModalOpen && (
        <div className="ads-modal-overlay" onClick={closeModal}>
          <div className="ads-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="ads-close-modal" onClick={closeModal}>
              &times;
            </button>
            <button 
              className="ads-modal-nav ads-modal-prev" 
              onClick={navigatePrevious}
            >
              &#10094;
            </button>
            <img
              src={modalImage.src}
              alt={modalImage.alt}
              className="ads-modal-image"
            />
            <button 
              className="ads-modal-nav ads-modal-next" 
              onClick={navigateNext}
            >
              &#10095;
            </button>
            <div className="ads-modal-counter">
              {currentImageIndex + 1} / {images.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CO2Facial;
